import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { getSizeFromDocument } from '../../utils/GetSizeFromDocument'

import {
  StyledButtonDownload,
  StyledContainer,
  StyledContentContainer,
  StyledDocumentContainer,
  StyledTitle,
} from './CardFinancial.styled'
import ElementFinancial from '../ElementFinancial/ElementFinancial'
import FinancialVariantEnum from '../../enums/FinancialVariantEnum'

const CardFinancial = ({
  isMobile,
  contents,
  parentPageNameForGtm,
  variant,
}) => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    const contentLength = contents.documents?.length
    let counter = contentLength
    if (contentLength === 1) counter = 2
    setCount(counter)
  }, [])

  return (
    <StyledContainer>
      {variant !== FinancialVariantEnum.investor && (
        <StyledTitle>{contents.blocTitle}</StyledTitle>
      )}
      {contents.documents && (
        <StyledDocumentContainer>
          {contents.documents.map((document, index) => (
            <StyledButtonDownload
              $count={count}
              key={index}
              document={document}
              description={getSizeFromDocument(document)}
              name={document.name}
              parentPageNameForGtm={parentPageNameForGtm}
            />
          ))}
        </StyledDocumentContainer>
      )}
      {contents.sections && (
        <StyledContentContainer $isMobile={isMobile}>
          {contents.sections.map((section, index) => (
            <ElementFinancial section={section} key={index} />
          ))}
        </StyledContentContainer>
      )}
    </StyledContainer>
  )
}

CardFinancial.propTypes = {
  contents: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  parentPageNameForGtm: PropTypes.string,
}

export default CardFinancial
